import { render, staticRenderFns } from "./iconLink.vue?vue&type=template&id=430854e6&scoped=true"
import script from "./iconLink.vue?vue&type=script&lang=js"
export * from "./iconLink.vue?vue&type=script&lang=js"
import style0 from "./iconLink.vue?vue&type=style&index=0&id=430854e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430854e6",
  null
  
)

export default component.exports